export const songs = [
  {
    title: "Butet",
    type: "Lagu Kasih Sayang",
    lyrics: `Butet... dipangungsian do apang mu, ale Butet...
Da margurilla da mardarurat, ale Butet...
Da margurilla da mardarurat, ale Butet...

Butet... so tung ngolngolan roha muna, ale Butet...
Paima tona manang surat, ale Butet...
Paima tona manang surat, ale Butet...

I doge, doge, doge i doge i, doge, doge
I doge, doge, doge i doge i, doge, doge

Butet... dipangungsian do apang mu, ale Butet...
Da margurilla da mardarurat, ale Butet...
Da margurilla da mardarurat, ale Butet...

Butet... so tung ngolngolan roha muna, ale Butet...
Paima tona manang surat, ale Butet...
Paima tona manang surat, ale Butet...

I doge, doge, doge i doge i, doge, doge
I doge, doge, doge i doge i, doge, doge

Butet... uuh uuh...
Butet... uuh uuh...`,
    meaning:
      "Lagu yang mengungkapkan kasih sayang seorang ayah kepada anaknya, mengajak untuk selalu bersama dan bahagia",
    occasion: "Acara keluarga",
    youtubeId: "Jdhkdje7WBQ",
  },


  {
    title: "Alusi Au",
    type: "Lagu Perpisahan",
    lyrics: `Alusi au... alusi au
Molo tarbahen hita
Asa unang hilang do
Hamoraon di hita

Alusi au... alusi au
Marnida ma hita
Songon do bulan
Na mangalehen bintang`,
    meaning:
      "Lagu yang dinyanyikan saat berpisah dengan orang terkasih, berharap kebahagiaan tetap menyertai",
    occasion: "Perpisahan",
    youtubeId: "usv-Yr2d-dU",
  },


  {
    title: "Sing Sing So",
    type: "Lagu Tradisional",
    lyrics: `Sing sing so... bani dainang
Tarbahen ma hita
Songon do manuk
Na mangalap beras

Sing sing so... sing sing so
Marsada ma hita
Asa unang hilang
Hamoraon di hita`,
    meaning:
      "Lagu yang mengajak untuk bersatu dan rukun, bekerja sama seperti burung yang mencari makan bersama",
    occasion: "Acara adat",
    youtubeId: "lZTlI4lhCN4",
  },


  {
    title: "O Tano Batak",
    type: "Lagu Tanah Air",
    lyrics: `O Tano Batak, tanah na uli
Godang do hamoraon mu
Sude ma ho tarbahen
Anak mu na so marroha

O Tano Batak... O Tano Batak
Holan do au mangalehen
Roha ni au mangido
Asa tarbahen salalu`,
    meaning:
      "Lagu cinta tanah air Batak, mengungkapkan kerinduan dan kebanggaan terhadap tanah kelahiran",
    occasion: "Acara nasional dan budaya",
    youtubeId: "uvsH0zkEmAQ",
  },


  {
    title: "Gondang Batak",
    type: "Lagu Instrumental",
    lyrics: `(Musik instrumental tradisional)
Dimainkan dengan:
- Gondang Sabangunan
- Taganing
- Ogung
- Sarune Bolon`,
    meaning:
      "Musik instrumental sakral yang digunakan dalam upacara adat dan ritual keagamaan",
    occasion: "Upacara adat dan ritual",
    youtubeId: "RtrsxZ0yP8E",
  },
];
